import { SelectedAge } from "../../models/SelectedAge";
import { SelectedArea } from "../../models/SelectedArea";
import { SelectedGender } from "../../models/SelectedGender";

export function GetCurveTitleForEVDAPage(
    selectedAge:SelectedAge,
    specificAge:number,
    selectedArea:SelectedArea,
    selectedGender:SelectedGender[]|SelectedGender):string | TemplateStringsArray | (string | TemplateStringsArray)[]{
        let title:string =""
   if(selectedArea===SelectedArea.France){
      title="evda_france_"
      title = GetEvdaTitle(title,selectedAge,specificAge,selectedGender as SelectedGender[])
   }
   else{
    title="evda_"
    title = GetEvdaTitle(title,selectedAge,specificAge,selectedGender as SelectedGender)
   }
   return title;
}

function GetEvdaTitle(
    title:string,
    selectedAge:SelectedAge,
    specificAge:number,
    selectedGender:SelectedGender[]|SelectedGender):string{
       if(specificAge===0){
        switch(selectedAge){
            case SelectedAge.birth:
                title+="birth_";
                break;
            case SelectedAge.sixtyFive:
                title+="65_"
                break;
        }
        if(Array.isArray(selectedGender)){
        title+=GetCurveTitleForGenderList(selectedGender)
        }
        else{
            title+=GetCurveTitleForGender(selectedGender)
        }
       }
       else{
        if(Array.isArray(selectedGender)){
          title+=GetCurveTitleForGenderList(selectedGender)
          title+="_with_param"
        }
        else{
            title+=GetCurveTitleForGender(selectedGender)
            title+="_with_param"  
        }
       }
       return title
    }

function GetCurveTitleForGenderList(selectedGender:SelectedGender[]):string{
    if(isGenderSelecterd(selectedGender,SelectedGender.male) &&
    isGenderSelecterd(selectedGender,SelectedGender.women)){
        return 'curve_title'
    }
    else{
        if(isGenderSelecterd(selectedGender,SelectedGender.male)){
            return 'men_curve_title'
        }
        else if(isGenderSelecterd(selectedGender,SelectedGender.male_women_diff)){
            return 'gap_curve_title'
        }
        else{
            return  'women_curve_title'
        }
    }
}

function GetCurveTitleForGender(selectedGender:SelectedGender):string{
    if(selectedGender===SelectedGender.male) 
   {
    return 'men_map_title'
    }
    else if(selectedGender===SelectedGender.women){
      return  'women_map_title'
    }
    else{
        return 'gap_map_title' 
    } 
}

function isGenderSelecterd(selectedGender:SelectedGender[], gender:SelectedGender):boolean{
   return selectedGender.indexOf(gender)>-1
}



